import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { LoanType } from '../../../../../../../../../common/constants/LoanType';
import { LoanTypeOptions } from '../../../../../../../../../common/constants/LoanTypeOptions';

export const LoanTypeField = () => {
    /** Loan types the user can pick: sub notes only allow the sub-note types; other loans exclude master/sub notes. */
    const getSelectableLoanTypeOptions = (isSubNote: boolean) =>
        LoanTypeOptions.filter((option) => {
            if (option.id === '') {
                return false; // the old select's "Loan Type..." placeholder row; the dropdown has its own placeholder
            }
            if (isSubNote) {
                return option.id === LoanType.SubNoteConstruction || option.id === LoanType.SubNoteFixFlip;
            }
            return (
                option.id !== LoanType.MasterNote &&
                option.id !== LoanType.SubNoteConstruction &&
                option.id !== LoanType.SubNoteFixFlip
            );
        });

    const value = useStandardLoanStore((state) => state.setup.loanTypeId);
    const isSubNote = useStandardLoanStore((state) => state.setupLoanContext.isSubNote);
    const existingLoanId = useStandardLoanStore((state) => state.setupLoanContext.existingLoanId);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <DropDownBox
            id='setupLoanTypeId'
            value={value ?? null}
            onChange={(loanTypeId: LoanType | null) => updateSetup({ loanTypeId: loanTypeId ?? undefined })}
            label='Loan Type'
            required={true}
            dataSource={getSelectableLoanTypeOptions(isSubNote)}
            displayExpr='name'
            valueExpr='id'
            placeholder='Loan Type...'
            searchEnabled={false}
            // Locked once the loan has been saved
            disabled={(existingLoanId ?? 0) > 0}
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
